import { createSharedComposable } from '@vueuse/shared';
import { useApiClient } from '@/app/core/api-client';
import { config } from '@/app/core/config';
import type { SupersetChartMeta, SupersetDashboardData, SupersetDashboardMeta, SupersetKeys } from '../../interfaces';

export const useSupersetApi = createSharedComposable(() => {
  const { transport, createMethod } = useApiClient();

  function getSupersetDashboards(moduleTab?: string) {
    return transport.get<{ data: SupersetDashboardData[] }>('v1/supersets/dashboards', {
      params: { module_tab: moduleTab },
    });
  }

  function getSupersetGuestToken(dashboardUuid: string) {
    return transport.post<{ token: string }>(`v1/supersets/guest_token/${dashboardUuid}`, {});
  }

  // BFF

  function bffGetDashboardMeta(name: string) {
    return transport.get<SupersetDashboardMeta[]>('/metastore/dashboard-meta', {
      params: { name },
      baseURL: config.bffUrl,
    });
  }

  function bffGetChartMeta(key: string) {
    return transport.get<SupersetChartMeta[]>('/metastore/chart-meta', {
      params: { key },
      baseURL: config.bffUrl,
    });
  }

  const bffGetKeys = createMethod<[string], SupersetKeys[]>(async (transport, locale) => {
    const { data } = await transport.get<SupersetKeys[]>('/metastore/keys', {
      params: { locale },
      baseURL: config.bffUrl,
    });
    return data;
  });

  return {
    getSupersetDashboards,
    getSupersetGuestToken,
    bffGetChartMeta,
    bffGetDashboardMeta,
    bffGetKeys,
  };
});
